import { LicenseManager } from "ag-grid-enterprise";
import { GlobalSearchProvider } from "context/GlobalSearch";
import { NotificationsProvider } from "context/Notifications";
import { createBrowserHistory } from "history";
import ForgotPassword from "pages/Forgot-Password";
import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import webSocket from "services/webSocket";
import AuthRoute from "./components/AuthRoute";
import Auth from "./services/authentication";

const auth = new Auth();
window.onload = function () {
  setTimeout(() => {
    if (auth.isAuthenticated()) {
      const { idToken } = auth.getAccessToken();
      webSocket.connect(idToken);
    }
  }, 2000);
};

const customHistory = createBrowserHistory();
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./pages/Login"));

const NewClient = React.lazy(() => import("./pages/NewClient"));
const Page404 = React.lazy(() => import("./pages/Page404"));
const Page500 = React.lazy(() => import("./pages/Page500"));

const LoginInternal = React.lazy(() => import("./pages/LoginInternal"));
const LoginExternal = React.lazy(() => import("./pages/LoginExternal"));
const LoginExternalMFA = React.lazy(() => import("./pages/LoginExternal/MFA"));
const LoginExternalForgotPassword = React.lazy(() =>
  import("./pages/LoginExternal/ForgotPassword"),
);
const LoginExternalResetPassword = React.lazy(() =>
  import("./pages/LoginExternal/ResetPassword"),
);
const LoginExternalExpiredPassword = React.lazy(() =>
  import("./pages/LoginExternal/ExpiredPassword"),
);
const LoginExternalPersonalDetails = React.lazy(() =>
  import("./pages/LoginExternal/PersonalDetails"),
);

class App extends Component {
  render() {
    return (
      <Router history={customHistory}>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path="/forgot-password"
              name="Forgot Password"
              render={(props) => <ForgotPassword {...props} />}
            />
            <Route
              exact
              path="/new-client"
              name="New Client"
              render={(props) => <NewClient {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/login-internal"
              name="Login Internal"
              render={(props) => {
                return <LoginInternal {...props} />;
              }}
            />
            <Route
              exact
              path="/login-external"
              name="Login External"
              render={(props) => {
                return <LoginExternal {...props} />;
              }}
            />
            <Route
              exact
              path="/login-external/mfa"
              name="Login External - MFA"
              render={(props) => {
                return <LoginExternalMFA {...props} />;
              }}
            />
            <Route
              exact
              path="/login-external/forgot-password"
              name="Login External - Forgot Password"
              render={(props) => {
                return <LoginExternalForgotPassword {...props} />;
              }}
            />
            <Route
              exact
              path="/login-external/reset-password"
              name="Login External - Reset Password"
              render={(props) => {
                return <LoginExternalResetPassword {...props} />;
              }}
            />
            <Route
              exact
              path="/login-external/expired-password"
              name="Login External - Expired Password"
              render={(props) => {
                return <LoginExternalExpiredPassword {...props} />;
              }}
            />
            <Route
              exact
              path="/login-external/personal-details"
              name="Login External - Personal Details"
              render={(props) => {
                return <LoginExternalPersonalDetails {...props} />;
              }}
            />
            <AuthRoute
              path="/"
              name="Home"
              render={(props) => (
                <GlobalSearchProvider>
                  <NotificationsProvider>
                    <DefaultLayout {...props} />
                  </NotificationsProvider>
                </GlobalSearchProvider>
              )}
            />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
